<template>
    <div class="mb-0">
       <Topbar />
       <div class="container-fluid text-left pl-2 pr-2 d-flex justify-content-center mb-0 main">
            <div class="card col-md-6 p-0">
                <div class="card-header pt-0 pb-0 small" :style="{ backgroundColor: moduloAtual().color }">
                    <span class="m-0 font-weight-bold text-white">
                        <router-link :to="'/inventario/detalhes/' + this.id">
                            <em class="fa fa-arrow-circle-left mr-2 text-white"></em>
                        </router-link>
                        Inventario {{ this.inventario.idprot_inventarios }} - Contagem
                        {{ this.inventario.Conferencia }}
                        <div v-show="carregando" class="spinner-grow">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </span>
                </div>
                <fieldset :disabled="carregando">
                    <div class="card-body bg-light small pl-2 pr-2 pt-2 pb-1">
                        <div class="row small">
                            <div class="col-12 col-md-12 col-lg-12">
                                <div class="card">
                                    <div class="card-body p-1">
                                        <div class="row">
                                            <div class="col-4 col-md-4 col-lg-4 font-weight-bold">
                                                Cliente:
                                            </div>
                                            <div class="col-8 col-md-8 col-lg-8">
                                                {{ inventario.fantasia }}
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-4 col-md-4 col-lg-4 font-weight-bold">
                                                Operador:
                                            </div>
                                            <div class="col-8 col-md-8 col-lg-8">
                                                {{ getUsername() }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body bg-light small pl-2 pr-2 pt-0 pb-0 mb-0">
                        <div class="mt-1">
                            <InputDefaultApp
                                id="endereco"
                                inputPlaceHolderSufixo="Digite o código do endereço"
                                titleScan="Escanear Endereço"
                                typeInputMode="text"
                                @displayScanFunction="buscarProdutos"
                                :enterKey="(e) => buscarProdutos(e.target.value)"
                                idInput="enderecoInput"
                                :errorMessage="this.enderecoNaoEncontrado ? 'Endereço não encontrado!' : null"
                                :toUpperCase="true"
                            >
                            </InputDefaultApp>
                        </div>
                    </div>

                    <div class="card-body bg-light small pl-2 pr-2 pt-0 pb-0" v-if="this.produtosCarregados">
                        <button
                        class="btn btn-primary btn-sm btn-block"
                        @click="dialogoProximoEndereco()"
                        >
                            Próximo endereço
                            <em class="fa fa-arrow-right ml-2"></em>
                        </button>

                        <div class="mt-1">
                            <InputDefaultApp
                                id="produto"
                                inputPlaceHolderSufixo="Digite o código do produto"
                                titleScan="Escanear Produto"
                                typeInputMode="numeric"
                                @displayScanFunction="buscarProduto"
                                :enterKey="(e) => buscarProduto(e.target.value)"
                                idInput="produtoInput"
                                :errorMessage="this.produtoNaoEncontrado ? 'Produto não encontrado!' : null"
                            >
                            </InputDefaultApp>
                        </div>
                    </div>
                    
                    <div class="card-body bg-light small pl-2 pr-2 pt-0" v-if="this.produtosCarregados">
                        <div class="row small">
                            <div class="col-12 col-md-12 col-lg-12">
                                <div class="card mb-2">
                                    <div class="card-header bg-info text-white text-center p-0">
                                        <span class="m-0">Ultimo Produto bipado</span>
                                    </div>
                                    <div class="card-body pt-1 pb-1">
                                        <div class="row">
                                            <div class="col-6 col-md-6 col-lg-6 font-weight-bold text-danger">
                                               SKU
                                            </div>
                                            <div class="col-6 col-md-6 col-lg-6">
                                                <span>{{ this.ultimoSKUBipado }}</span>
                                                <em class="fa fa-check-circle text-success ml-2" v-if="this.produtoFinalizado"></em>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-6 col-md-6 col-lg-6 font-weight-bold text-danger">
                                               Codido de Barras
                                            </div>
                                            <div class="col-6 col-md-6 col-lg-6">
                                                <span>{{ this.ultimoBipado }}</span>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-6 col-md-6 col-lg-6 font-weight-bold text-danger">
                                                Qtde
                                            </div>
                                            <div class="col-6 col-md-6 col-lg-6">
                                                <span>{{ this.ultimaQuantidade }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="this.produtosCarregados" class="table-reponsive">
                            <table class="table table-hover table-bordered small">
                                <caption></caption>
                                <thead>
                                    <th class="text-center pt-0 pb-0">Produto</th>
                                    <th class="text-center pt-0 pb-0">Ações</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(item) in produtos" :key="item.idprodutos+item.lote+item.validade">
                                        <td class="p-1">
                                            <div class="card m-0 small">
                                                <div class="card-body p-1 pt-2 pb-2">
                                                    <em 
                                                    :id="'icon_'+item.idprodutos"
                                                    :class="['fa', 'fa-circle', 'icon-status', item.class]"
                                                    ></em>
                                                    
                                                    <div class="row">
                                                        <div class="col-5 col-md-5 col-lg-5 font-weight-bold text-danger">
                                                            SKU
                                                        </div>
                                                        <div class="col-7 col-md-7 col-lg-7">
                                                            {{ item.sku }}
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-5 col-md-5 col-lg-5 font-weight-bold text-danger">
                                                            Cod.Barras
                                                        </div>
                                                        <div class="col-7 col-md-7 col-lg-7">
                                                            {{ item.codbarras }}
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-5 col-md-5 col-lg-5 font-weight-bold text-danger">
                                                            Descricao
                                                        </div>
                                                        <div class="col-7 col-md-7 col-lg-7">
                                                            {{ getDescricao(item.descricao) }}
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-5 col-md-5 col-lg-5 font-weight-bold text-danger">
                                                            Lote
                                                        </div>
                                                        <div class="col-7 col-md-7 col-lg-7">
                                                            {{ item.lote ? item.lote : "Não tem!" }}
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-5 col-md-5 col-lg-5 font-weight-bold text-danger">
                                                            Validade
                                                        </div>
                                                        <div class="col-7 col-md-7 col-lg-7">
                                                            {{ item.validade ? item.validade : "Não Tem!" }}
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-5 col-md-5 col-lg-5 font-weight-bold text-danger">
                                                            Qtde conf.
                                                        </div>
                                                        <div class="col-7 col-md-7 col-lg-7">
                                                            {{ item.quantidadeConferencia }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </td>
                                        <td class="tex-center p-1">
                                            <div class="card m-0 small">
                                                <div class="card-body p-1 pt-4 pb-4 text-center">

                                                    <button class="btn btn-primary btn-sm mt-1 mb-1" @click="setProdutoAcoes(item)" data-toggle="modal" data-target="#modalAcoes">
                                                        <em class="fa fa-align-justify"></em>
                                                    </button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
        <LogoutModal/>
        <div v-if="!this.produtosCarregados" class="text-center text-secondary">
            <em class="mt-2 mb-3 fa fa-info-circle fa-3x"></em>
            <h6>Bipe o endereço ex: 1A.PPL.13.01.A</h6>
        </div>
        <Modal
            id="modalProximoEndereco"
            title="Confirme:"
            :confirmFunction="() => proximoEndereco()"
            :carregando="carregando"
            :cancelFunction="() => closeModal('modalProximoEndereco')"
        >
            Deseja seguir para o próximo Endereço?
        </Modal>
        <Modal
            id="modalZerar"
            title="Confirme:"
            :confirmFunction="() => zerarContagem()"
            :carregando="carregando"
            :cancelFunction="() => closeModal('modalZerar')"
        >
            Deseja zerar a contagem do produto abaixo?
            <br>
            <br>
            {{ this.produtoAcoes.descricao }}
        </Modal>
        <Modal
            id="modalEditar"
            title="Alterar Lote/Validade"
            :confirmFunction="() => editarContagemProduto()"
            :carregando="carregando"
            :cancelFunction="() => closeModal('modalEditar')"
        >
           <span>{{ this.produtoAcoes.descricao }}</span>
           <hr>
           <span v-if="this.errorLoteValidade" class="text-danger">{{ this.errorLoteValidade }}</span>
           <div class="text-left">
                <label for="loteInputEditar" class="font-weight-bold">LOTE</label>
                <input
                id="loteInputEditar"
                inputmode="text"
                type="text"
                class="form-control form-control-sm"
                >
                <label for="dataValidadeInput" class="font-weight-bold">VALIDADE</label>
                <CustomDateInput v-model="dateValueModal" idInput="validadeAjustarInput" />
           </div>
           
        </Modal>

        <Modal
            id="modalInserirQuantidade"
            title="Inserir Quantidade:"
            :confirmFunction="() => InserirQuantidade()"
            :cancelFunction="() => closeModal('modalInserirQuantidade')"
            :carregando="carregando"
        >
            <div class="text-left">
                <label for="qtde">* Quantidade</label>
                <input
                    type="number"
                    inputmode="numeric"
                    class="form-control form-control-sm"
                    value="1"
                    id="qtde"
                    autofocus="on"
                    @keypress.enter="InserirQuantidade"
                    >
            </div>
        </Modal>

        <Modal
            id="modalError"
            title="Aviso"
            :carregando="carregando"
            :buttonList="[]"
            :cancelFunction="() => closeModal('modalError')"
            cancelText="OK"
        >
            <div class="small text-center">
                <em class="fa fa-info-circle text-warning fa-3x"></em>
                <br>
                <br>
                <span>{{ this.errorMessageModal }}</span>
            </div>
        </Modal>

        <Modal
            id="modalAcoes"
            title="Ações"
            :buttonList="[]"
            :noFooter="true"
            :cancelFunction="() => closeModal('modalAcoes')"
        >
            <button class="btn btn-info btn-sm btn-block" @click="dialogoInserirQuantidade()">
                Inserir Conferência
                <em class="fa fa-edit ml-2"></em>
           </button>
           <button class="btn btn-success btn-sm btn-block" @click="dialogoEdicaoContagem()">
                Alterar Lote/Validade
                <em class="fa fa-calendar ml-2"></em>
           </button>
           <button class="btn btn-warning btn-sm btn-block" @click="confirmarZeramentoFechamento()">
                Desfazer contagem
                <em class="fa fa-undo ml-2"></em>
           </button>
           <button class="btn btn-danger btn-sm btn-block" @click="closeModal('modalAcoes')">
                Sair
                <em class="fa fa-times ml-2"></em>
           </button>
        </Modal>
    </div>
</template>

<script>
// @ is an alias to /src
import Topbar from '@/components/Topbar.vue'
import LogoutModal from '@/components/LogoutModal.vue'
import InputDefaultApp from '../components/InputDefaultApp.vue';
import CustomDateInput from '../components/CustomDateInput.vue';
import ViewMixin from './ViewMixin'
import { DEFAULT_ERROR_MESSAGE, ServerErrorException, TokenInvalidoException } from '../services/exceptions'
import api, { getUsername, getUserId } from "../services/api";
import api_inventario from '../services/api-inventario'
import { dateFormat } from "../utils";
import Modal from "../components/Modal.vue";
import $ from "jquery";
import audioService from '@/services/audioService.js';

export default {
    name: 'InventarioContagem',
    mixins: [ViewMixin],
    components: {
        Topbar,
        LogoutModal,
        Modal,
        InputDefaultApp,
        CustomDateInput,
    },

    data: () => {
        return {
            dados: [],
            inventario : {},
            id: null,
            enderecoReferencia: null,
            idEnderecoReferencia: null,
            produtos: [],
            produtosCarregados: false,
            produtoNaoEncontrado: false,
            enderecoNaoEncontrado: false,
            clienteReferencia: 0,
            ultimoBipado: '--------',
            ultimaQuantidade: '--------',
            ultimoSKUBipado: '--------',
            produtoAcoes: {
                descricao: ''
            },
            dateValueModal: '',
            errorLoteValidade: null,
            errorMessageModal: null,
            produtoFinalizado: false,
        };
    },

    async mounted() {
        try {
            await this.validarToken();
            await this.getInventary();
        } catch (e) {
            if (e instanceof TokenInvalidoException) {
                this.handleTokenInvalidoException();
            } else if (e instanceof ServerErrorException) {
                alert(e.message);
            } else {
                alert(DEFAULT_ERROR_MESSAGE);
            }      
        }
    },

    methods: {
        showErrorModal(message) {
            this.errorMessageModal = message;
            $("#modalError").modal('show');
        },

        playSoundWarning() {
            audioService.ops();
        },

        playSoundSuccess() {
            audioService.success();
        },

        getUsername,
        getUserId,
        async validarToken() {
            this.carregando = true;
            await api.get("/validar-token");
            this.carregando = false;
        },

        closeModal(modalId) {
            $('#'+modalId).modal('hide');
            this.onModalClosed();
        },

        setProdutoAcoes(produto) {
            this.produtoAcoes = produto;
        },

        onModalClosed() {
            let produtoInput = document.getElementById("produtoInput");

            if (produtoInput !== null && produtoInput !== undefined) {
                setTimeout(() => {
                    produtoInput.focus();
                    produtoInput.select();
                }, 500);
            }
        },

        formatarData(data) {
            // Divide a data original em dia, mês e ano
            const partes = data.split('/');
            const dia = partes[0];
            const mes = partes[1];
            const ano = partes[2];
            
            // Cria uma nova data no formato "yyyy-mm-dd"
            const novaData = `${ano}-${mes}-${dia}`;
            
            return novaData;
        },

        getDescricao(s) {
            if (s.length > 17) {
                return s.substring(0, 17) + "...";
            }

            return s;
        },

        async getInventary() {
            this.carregando = true; 
            
            try {
                let id = this.$route.params.id;
                this.id= id;
                
                let response = await api_inventario.get(`/inventario/${id}`);
                this.inventario = response.data.inventario;
                this.inventario["Conferencia"] = this.$route.params.conferencia;

                setTimeout(() => {
                    let enderecoInput = document.getElementById('enderecoInput');
                    enderecoInput.focus();
                }, 250);
            } catch (e) {
                console.error(e);
            }
            this.carregando = false;
        },

        async buscarProdutos(valueInput) {
            this.carregando = true;
            this.produtoNaoEncontrado = false;

            try {
                let enderecoInput = document.getElementById('enderecoInput');
               
                enderecoInput.style.border = "1px solid #CCC";
                this.enderecoNaoEncontrado = false;
                this.produtos = [];
                let id = this.$route.params.id;

                let descricao = {
                    idInventario: id,
                    idConferencia: this.inventario.Conferencia,
                    descricaoEndereco: valueInput
                }
                
                let response1 = await api_inventario.post(
                    '/inventario/enderecos',
                    descricao,
                    {
                        headers: {
                            'Cache-Control': 'no-cache'
                        }
                    }
                );
                
                let produtosComDivergencia = [];
                let produtosSemDivergencia = [];
                
                if (response1.data.enderecos.length > 0) {

                    let endereco = {
                        idInventario: id,
                        idConferencia: this.inventario.Conferencia,
                        idEndereco: response1.data.enderecos[0].idenderecamento
                    }

                    $("#enderecoInput").val(response1.data.enderecos[0].descricao);
                    this.enderecoReferencia = response1.data.enderecos[0].descricao;
                    this.idEnderecoReferencia = response1.data.enderecos[0].idenderecamento;
                    
                    let response2 = await api_inventario.post('/endereco/produtos', endereco);
                    
                    response2.data.produtos.forEach((e) => {
                        let startcolor = ' text-warning';

                        if (e.quantidadeConferencia === e.quantidade) {
                            startcolor = " text-success";
                            produtosSemDivergencia.push(e);
                        } else {
                            produtosComDivergencia.push(e);
                        }

                        if (e.quantidade > e.quantidadeConferencia && e.quantidadeConferencia === 0) {
                            startcolor = ' text-danger';
                        }

                        e["validade"] = dateFormat(e.validade);
                        e["class"] = e.quantidadeConferencia === 0 ? " text-danger" : startcolor;
                        e["class"] = e.quantidadeConferencia === 0 && e.quantidade === 0 ? " text-success" : startcolor;
                    }, this);

                    this.produtos = produtosComDivergencia.concat(produtosSemDivergencia);
                    this.dados = produtosComDivergencia.concat(produtosSemDivergencia);
                    this.produtosCarregados = response2.data.produtos.length > 0;
                    this.clienteReferencia = response2.data.produtos[0].produtos_clientes_idclientes;
                    
                    setTimeout(() => {
                        let produtoInput = document.getElementById('produtoInput');
                        produtoInput.focus();
                        produtoInput.select();
                        produtoInput.value = "";
                    }, 250);
                } else {

                    setTimeout(() => {
                        enderecoInput.select();
                        enderecoInput.focus();  
                    }, 250);

                    this.playSoundWarning();
                    this.enderecoNaoEncontrado = true;
                    enderecoInput.style.border = "1px solid red";
                }
            } catch (e) {
                this.showErrorModal(e.message);
                this.playSoundWarning();

                setTimeout(() => {
                    let produtoInput = document.getElementById('produtoInput');
                    produtoInput.focus();
                    produtoInput.select();
                    produtoInput.value = "";
                }, 250);
            }
            this.carregando = false;
        },

        list() {
            this.produtos = [];
            this.buscarProdutos(this.enderecoReferencia);
            document.getElementById('pesquisa').value = "";
        },

        changeProdutoInputMode() {
            let inputMode = this.produtoInputMode;
            if (inputMode === 'none') {
                this.produtoInputMode = 'text';
                this.placeHolderProduto = 'Digite o produto';
                this.produtoInputIcon = 'fa fa-barcode text-secondary icon-input';
            } else {
                this.produtoInputMode = 'none';
                this.placeHolderProduto = 'Bipe o produto';
                this.produtoInputIcon = 'fa fa-keyboard text-secondary icon-input';
            }
            let produtoInput = document.getElementById('produtoInput');
            produtoInput.focus();
        },

        async buscarProduto(valueInput) {
            this.carregando = true;
            this.produtoFinalizado = false;

            try {
                let produtoInput = document.getElementById('produtoInput');
               
                produtoInput.style.border = "1px solid #CCC";
                this.produtoNaoEncontrado = false;

                let produto = {
                    idCliente: this.clienteReferencia,
                    barCode: valueInput
                }
                
                let response1 = await api_inventario.post('/produto/codigodebarras', produto);

                

                if (response1.data.produto.length > 0) {
                    this.produtoNaoEncontrado = false;
                    if (this.produtos.includes(response1.data.produto[0])) {
                        this.produtos.push(response1.data.produto[0]);
                    } else {
                        for (let p of this.produtos) {
                            if (p.idprodutos == response1.data.produto[0].idprodutos) {
                                this.destacarLinhaBipada(p.codbarras);

                                let produtoUpdate = {
                                    "idConferencia": parseInt(this.$route.params.conferencia),
                                    "idUsuario": getUserId(),
                                    "idInventario": parseInt(this.id),
                                    "idProduto": response1.data.produto[0].idprodutos,
                                    "idEndereco": this.idEnderecoReferencia
                                };

                                let respose2 = await api_inventario.post('/contagem/atualizar', produtoUpdate);
                                if (respose2.data.update) {
                                    p.quantidadeConferencia = p.quantidadeConferencia+1;
                                }

                                if (p.quantidade != p.quantidadeConferencia && p.quantidadeConferencia === 0) {
                                    document.getElementById('icon_' + p.idprodutos).setAttribute('class', 'fa fa-circle text-danger icon-status');
                                } else if (p.quantidade !== p.quantidadeConferencia) {
                                    document.getElementById('icon_' + p.idprodutos).setAttribute('class', 'fa fa-circle text-warning icon-status');
                                } else if (p.quantidade > 0 && p.quantidadeConferencia === p.quantidade) {
                                    document.getElementById('icon_' + p.idprodutos).setAttribute('class', 'fa fa-circle text-success icon-status');
                                    this.descerLinhaFinalizada(p.codbarras);
                                    this.produtoFinalizado = true;
                                    this.playSoundSuccess();
                                }
                                this.ultimoBipado = p.codbarras;
                                this.ultimaQuantidade = p.quantidadeConferencia;
                                this.ultimoSKUBipado = p.sku;

                                break;
                            }
                        }

                        this.dados = this.produtos;
                        setTimeout(() => {
                            produtoInput.focus();
                            produtoInput.select();
                        }, 100);
                    }
                } else {
                    this.produtoNaoEncontrado = true;
                    this.playSoundWarning();
                    setTimeout(() => {
                        produtoInput.select();
                        produtoInput.focus();  
                    }, 1000);
                }
            } catch (e) {
                this.showErrorModal(e.message);
                this.playSoundWarning();
            }
            this.carregando = false;
        },

        destacarLinhaBipada(codbarras) {
            let newList = [];

            for (const item of this.produtos) {
                if (item.codbarras === codbarras) {
                    newList.push(item);
                    break;
                }
            }

            for (const item of this.produtos) {
                if (item.codbarras !== codbarras) {
                    newList.push(item);
                }
            }

            this.produtos = newList;
        },

        descerLinhaFinalizada(codbarras) {
            let newList = [];

            for (const item of this.produtos) {
                if (item.codbarras !== codbarras) {
                    newList.push(item);
                }
            }
            
            for (const item of this.produtos) {
                if (item.codbarras === codbarras) {
                    newList.push(item);
                    break;
                }
            }

            this.produtos = newList;
        },

        confirmarZeramentoFechamento() {
            $("#modalAcoes").modal("hide");

            setTimeout(() => {
                $("#modalZerar").modal("show");
            }, 100);
        },

        async zerarContagem() {
            let produtoUpdate = {
                "idInventario": parseInt(this.id),
                "idProduto": this.produtoAcoes.idprodutos,
                "idConferencia": parseInt(this.$route.params.conferencia),
                "idEndereco": this.idEnderecoReferencia,
                "idUsuario": getUserId()
            }
            let response = await api_inventario.post('/contagem/desfazer', produtoUpdate);

            
            if (response.data.update) {
                for (let p of this.produtos) {
                    if (p.idprodutos == this.produtoAcoes.idprodutos) {
                        p["quantidadeConferencia"] = 0;
                        document.getElementById('icon_' + p.idprodutos).setAttribute('class', 'fa fa-circle text-danger icon-status');
                        if (p.quantidade == 0) {
                            document.getElementById('icon_' + p.idprodutos).setAttribute('class', 'fa fa-circle text-success icon-status');
                        }
                        
                        if (p.codbarras === this.ultimoBipado) {
                            this.ultimaQuantidade = 0;
                            this.produtoFinalizado = false;
                        }

                        break;
                    } 
                }
            }

            this.closeModal("modalZerar");
        },

        dialogoEdicaoContagem() {
            $("#modalAcoes").modal("hide");
            setTimeout(() => {
                $("#modalEditar").modal("show");
            }, 100);
            
            setTimeout(() => {
                $("#loteInputEditar").val(this.produtoAcoes.lote);

                if (this.produtoAcoes.validade !== null && this.produtoAcoes.validade !== "") {
                    this.dateValueModal = this.formatarData(this.produtoAcoes.validade);
                } else {
                    this.dateValueModal = null;
                }

                setTimeout(() => {
                    $("#loteInputEditar").focus();
                    $("#loteInputEditar").select();
                }, 500);
            }, 250);
        },

        isValidDate(dateString) {
            // Verifica se o formato é válido: yyyy-mm-dd
            const regex = /^\d{4}-\d{2}-\d{2}$/;
            if (!dateString.match(regex)) {
                return false;
            }

            // Desestrutura o ano, mês e dia
            const [year, month, day] = dateString.split('-').map(Number);

            // Verifica se a data existe no calendário
            const date = new Date(year, month - 1, day);  // Lembre-se: meses em JavaScript vão de 0 a 11
            
            return date.getFullYear() === year &&
            date.getMonth() === month - 1 &&
            date.getDate() === day;
        },

        async editarContagemProduto() {

            if (!this.isValidDate(this.dateValueModal)) {
                this.errorLoteValidade = "Data inválida!";
                $("#validadeAjustarInput").css("border", "1px solid red");
                $("#validadeAjustarInput").focus();
                return;
            }

            this.produtoAcoes["lote"] = $("#loteInputEditar").val();
            this.produtoAcoes["validade"] = dateFormat(this.dateValueModal);

            this.closeModal("modalEditar");

            let produtoUpdate = {
                "validade": this.dateValueModal,
                "lote": this.produtoAcoes.lote,
                "idInventario": parseInt(this.id),
                "idProduto": parseInt(this.produtoAcoes.idprodutos),
                "idEndereco": this.idEnderecoReferencia,
            }
            let response = await api_inventario.post('/contagem/atualizarlotevalidade', produtoUpdate);
            if (response.data.update) {
                this.produtoAcoes["validade"] = dateFormat(this.produtoAcoes["validade"]);
            }
        },

        dialogoProximoEndereco() {
            setTimeout(() => {
                $("#modalProximoEndereco").modal("show");
            }, 100);
        },

        async proximoEndereco() {
            this.produtoNaoEncontrado = false;

            let body = {
               "idInventario": parseInt(this.id),
                "idConferencia": parseInt(this.$route.params.conferencia)
            };

            let response = await api_inventario.post('/contagem/proximoendereco', body);
            
            
            $("#modalProximoEndereco").modal("hide");
            
            if (response.data.enderecos.length > 0) {
                let i = 0;
                let proximoEndereco = null;
                for (const endereco of response.data.enderecos) {
                    if (endereco.descricao === this.enderecoReferencia) {
                        
                        if (i+1 === response.data.enderecos.length) {
                            this.showErrorModal("Não há mais endereço para contagem!");
                            break;
                        }

                        proximoEndereco = response.data.enderecos[i+1];
                        break;
                    }

                    i++;
                }

                if (proximoEndereco !== null) {
                    $('#enderecoInput').val(proximoEndereco.descricao);
                    this.enderecoReferencia = proximoEndereco.descricao;
                    this.idEnderecoReferencia = proximoEndereco.idenderecamento;
                    this.buscarProdutos(this.enderecoReferencia);
                }
            } else {
                this.playSoundWarning();
                this.showErrorModal('Proximo Endereço não encontrado!');
            }
        },

        dialogoInserirQuantidade() {
            $("#modalAcoes").modal('hide');
            $("#modalInserirQuantidade").modal('show');

            setTimeout(() => {
                $("#qtde").val(1);
                $("#qtde").focus();
                $("#qtde").select();
            }, 1000);
        },

        async InserirQuantidade() {
            try {

                let qtdeInput = document.getElementById('qtde');
                let body = {
                    idInventario: this.inventario.idprot_inventarios,
                    idProduto: this.produtoAcoes.idprodutos,
                    idEndereco: this.idEnderecoReferencia,
                    idConferencia: this.inventario.Conferencia,
                    quantidade: qtdeInput.value,
                    idUsuario: this.getUserId()
                };

                let response = await api_inventario.post('/contagem/inserir', body);

                if (JSON.stringify(response).includes("inserido")) {
                    if (response.data.details.inserido > 0) {

                        if (qtdeInput.value != this.produtoAcoes.quantidade) {
                            document.getElementById('icon_' + this.produtoAcoes.idprodutos).setAttribute('class', 'fa fa-circle text-warning icon-status');
                        }  else if (qtdeInput.value == 0) {
                            document.getElementById('icon_' + this.produtoAcoes.idprodutos).setAttribute('class', 'fa fa-circle text-danger icon-status');
                        } else if (qtdeInput.value == this.produtoAcoes.quantidade) {
                            document.getElementById('icon_' + this.produtoAcoes.idprodutos).setAttribute('class', 'fa fa-circle text-green icon-status');
                        }

                        this.ultimoBipado = this.produtoAcoes.codbarras;
                        this.ultimaQuantidade = qtdeInput.value;
 
                        for (let produto of this.produtos) {
                            if (produto.idprodutos === this.produtoAcoes.idprodutos) {
                                produto["quantidadeConferencia"] = qtdeInput.value;
                                break;
                            }
                        }
                    }
                } else if (JSON.stringify(response).includes("error")) {
                    this.showErrorModal(response.error);
                    this.playSoundWarning();
                }
            } catch(e) {
                alert(e.message);
            }

            this.closeModal("modalInserirQuantidade");
        },
    }
}
</script>

<style scoped lang="scss">
    .icon-input {
        position: absolute;
        top: 20%;
        right: 3%;
        font-size: 18px;
    }

    .icon-input-2 {
        position: absolute;
        top: 20%;
        right: 30px;
        font-size: 18px;
    }

    .icon-cam {
        position: absolute;
        top: 20%;
        right: 5px;
        font-size: 18px;
    }

    .icon-status {
        position: absolute;
        top: 5px;
        right: 3%;
    }

    .main {
        padding-top: 55px;
    }
</style>